import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create(
  {
    baseURL: API_URL
  }
);

api.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error);
  }
)

api.interceptors.response.use(undefined, (error) => {
  const statusCode = error.response?.status;

  if (statusCode === 401) {
    localStorage.clear();
    localStorage.setItem('redirect_url', window.location.href);

    window.location = window.location.protocol + "//" + window.location.host + "/login"
  }

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.error(error);
  }

  return Promise.reject(error);
})

export default api;